import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * Subtle, premium watermark for any AI-generated feedback card.
 *
 * Variants:
 *   - "inline"  → small pill placed top-right of feedback header (default)
 *   - "footer"  → bottom footer line under a feedback block
 *   - "stamp"   → compact mono stamp for printed/exportable reports
 *
 * Always carries the "Winhouse AI Learning System" attribution so students
 * can recognise the source of their feedback at a glance.
 */
const WinhouseAIFeedbackBadge = ({ variant = 'inline', model, className = '' }) => {
  const subtitle = model ? `· model: ${model}` : '';
  if (variant === 'footer') {
    return (
      <div
        data-testid="winhouse-ai-badge"
        className={`mt-4 pt-3 border-t border-gray-100 flex items-center justify-between gap-2 text-[11px] text-gray-400 ${className}`}
      >
        <span className="inline-flex items-center gap-1.5">
          <Sparkles className="h-3 w-3 text-red-700" />
          <span className="font-semibold text-gray-500 tracking-wide uppercase">Winhouse AI Feedback</span>
          <span className="hidden sm:inline">{subtitle}</span>
        </span>
        <span className="hidden sm:inline italic">Generated by the Winhouse AI Learning System</span>
      </div>
    );
  }
  if (variant === 'stamp') {
    return (
      <div
        data-testid="winhouse-ai-badge"
        className={`inline-flex items-center gap-1 px-2 py-0.5 rounded border border-gray-200 bg-white text-[10px] font-mono tracking-wider text-gray-500 ${className}`}
      >
        <Sparkles className="h-2.5 w-2.5 text-red-700" />
        WINHOUSE AI · {model || 'Learning System'}
      </div>
    );
  }
  // inline (default)
  return (
    <span
      data-testid="winhouse-ai-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/5 border border-black/10 text-[10px] uppercase tracking-[0.15em] font-semibold text-gray-700 ${className}`}
      title="Generated by the Winhouse AI Learning System"
    >
      <Sparkles className="h-3 w-3 text-red-700" />
      Winhouse AI
    </span>
  );
};

export default WinhouseAIFeedbackBadge;
